var alignment_rtlignore_default = {
  "alignLeft": "fwHiT",
  "textWrapNowrap": "CRPRk",
  "alignRight": "WSYXU",
  "alignCenter": "OJTQo",
  "sizeFullWidth": "LOt6s",
  "renderedInTable": "wqG-8",
  "sizeOriginal": "ijjEe",
  "sizeContent": "WP0lw",
  "sizeSmall": "J80fR",
  "sizeSmallCenter": "kxVvV",
  "flex": "vwtZU",
  "LEFT": "pJWhf",
  "CENTER": "N8eLw",
  "RIGHT": "-Gytp",
  "AUTO": "Lo5JP",
  "JUSTIFY": "yT--P"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
